const Constant = {
  firebaseConfig: {
    apiKey: "AIzaSyCGpGk7eALlz7jwc7T_5Gupt_quMrTkfqs",
    authDomain: "halth-production.firebaseapp.com",
    projectId: "halth-production",
    storageBucket: "halth-production.appspot.com",
    messagingSenderId: "47323350875",
    appId: "1:47323350875:web:5e30efd00d7d54f24f7c7e",
    measurementId: "G-1E3GVXXQB0"
  },
  resetPasswordUrl: 'https://halth.com/auth/reset-password',
  freePlanCmsId: '2Qh0DtjzkADYTZ8CaGAKkV',
  stripePublicKey:
    'pk_live_51KVY51ChvfRqVhIYxAt4a3UKbaaabGMWB8TCg05Ovb0AWCJ4Fd3DV1IbLnr4WdYxOogc83pXvpZBfHTRQxogJS8W00szjbwnbW'
};

export default Constant;
